@if(isFooterVisible){
<div class="mb-1">
  <div
    class="container"
    style="
      background-color: white;
      padding-bottom: 2.5rem;
      padding-top: 1.5rem;
    "
  >
    <div class="row justify-content-center">
      <!-- Start::devoluciones (lg+) -->
      <div
        class="col-3 py-0 hidden lg:block"
        style="cursor: pointer"
        [routerLink]="['/sitio/politicas/cambios-devolucion']"
      >
        <div class="row m-0">
          <div class="col-4 py-0">
            <img
              ngSrc="../../../../../assets/svg/11.svg"
              width="80"
              height="80"
              alt="devoluciones"
            />
          </div>

          <div
            class="col-8 py-0 flex flex-column justify-content-center align-items-start"
            style="color: #094cac"
          >
            <span>Cambios y</span>
            <span class="fw-bold">DEVOLUCIONES</span>
          </div>
        </div>
      </div>
      <!-- End::devoluciones (lg+) -->

      <!-- Start::devoluciones (sm y md) -->
      <div
        class="col-3 py-0 hidden sm:block lg:hidden"
        style="cursor: pointer"
        [routerLink]="['/sitio/politicas/cambios-devolucion']"
      >
        <div class="row m-0">
          <div class="col-12 py-0">
            <img
              ngSrc="../../../../../assets/svg/11.svg"
              width="80"
              height="80"
              alt="devoluciones"
            />
          </div>

          <div
            class="col-12 py-0 flex flex-column justify-content-center align-items-start"
            style="color: #094cac"
          >
            <span>Cambios y</span>
            <span class="fw-bold">DEVOLUCIONES</span>
          </div>
        </div>
      </div>
      <!-- End::devoluciones (sm y md) -->

      <!-- Start::devoluciones (xs) -->
      <div
        class="col-12 py-0 block lg:hidden cursor-pointer"
        style="margin-bottom: 15px"
        [routerLink]="['/sitio/politicas/cambios-devolucion']"
      >
        <div class="row m-0">
          <div class="col-4 py-0 flex justify-content-center">
            <img
              ngSrc="../../../../../assets/svg/11.svg"
              width="80"
              height="80"
              alt="devoluciones"
            />
          </div>

          <div
            class="col-8 py-0 flex flex-column justify-content-center"
            style="color: #094cac"
          >
            <span>Cambios y</span>
            <span class="fw-bold">DEVOLUCIONES</span>
          </div>
        </div>
      </div>
      <!-- End::devoluciones (xs) -->

      <!-- Start::tiendas (lg+) -->
      <div
        class="col-3 py-0 hidden lg:block"
        style="cursor: pointer"
        [routerLink]="['/sitio/tiendas']"
      >
        <div class="row m-0">
          <div class="col-4 py-0">
            <img
              ngSrc="../../../../../assets/svg/12.svg"
              width="70"
              height="70"
              alt="tiendas"
            />
          </div>
          <div
            class="col-8 py-0 flex flex-column justify-content-center align-items-start"
            style="color: #094cac"
          >
            <span>Nuestras</span>
            <span class="fw-bold">TIENDAS</span>
          </div>
        </div>
      </div>
      <!-- End::tiendas (lg+) -->

      <!-- Start::tiendas (sm y md) -->
      <div
        class="col-3 py-0 hidden sm:block lg:hidden"
        style="cursor: pointer"
        [routerLink]="['/sitio/tiendas']"
      >
        <div class="row m-0">
          <div class="col-12 py-0">
            <img
              ngSrc="../../../../../assets/svg/12.svg"
              width="70"
              height="70"
              alt="tiendas"
            />
          </div>
          <div
            class="col-12 py-0 flex flex-column justify-content-center align-items-start"
            style="color: #094cac"
          >
            <span>Nuestras</span>
            <span class="fw-bold">TIENDAS</span>
          </div>
        </div>
      </div>
      <!-- End::tiendas (sm y md) -->

      <!-- Start::tiendas (xs) -->
      <div
        class="col-12 py-0 block lg:hidden"
        style="cursor: pointer; margin-left: 0px; margin-bottom: 15px"
        [routerLink]="['/sitio/tiendas']"
      >
        <div class="row m-0">
          <div class="col-4 py-0 flex justify-content-center">
            <img
              ngSrc="../../../../../assets/svg/12.svg"
              width="70"
              height="70"
              alt="tiendas"
            />
          </div>
          <div
            class="col-8 py-0 flex flex-column justify-content-center"
            style="color: #094cac"
          >
            <span>Nuestras</span>
            <span class="fw-bold">TIENDAS</span>
          </div>
        </div>
      </div>
      <!-- End::tiendas (xs) -->

      <!-- Start::catálogos (lg+) -->
      @if(countryCode!== 'pe'){
      <div
        class="col-3 py-0 hidden lg:block"
        style="cursor: pointer"
        (click)="openInNewTab('/catalogos/listado-catalogos')"
      >
        <!-- <a href="/catalogos/listado-catalogos" target="_blank"> -->
        <div class="row m-0">
          <div class="col-4 py-0">
            <img
              ngSrc="../../../../../assets/svg/13.svg"
              width="50"
              height="70"
              alt="catálogos"
            />
          </div>
          <div
            class="col-8 py-0 flex flex-column justify-content-center align-items-start"
            style="color: #094cac"
          >
            <span>Nuestros</span>
            <span class="fw-bold">CATÁLOGOS</span>
          </div>
        </div>
      </div>
      }
      <!-- End::catálogos (lg+) -->

      <!-- Start::catálogos (sm y md) -->
      @if(countryCode!== 'pe'){
      <div
        class="col-3 py-0 hidden sm:block lg:hidden"
        style="cursor: pointer"
        (click)="openInNewTab('/catalogos/listado-catalogos')"
      >
        <!-- <a href="/catalogos/listado-catalogos" target="_blank"> -->
        <div class="row m-0">
          <div class="col-12 py-0">
            <img
              ngSrc="../../../../../assets/svg/13.svg"
              width="50"
              height="70"
              alt="catálogos"
            />
          </div>
          <div
            class="col-12 py-0 flex flex-column justify-content-center align-items-start"
            style="color: #094cac"
          >
            <span>Nuestros</span>
            <span class="fw-bold">CATÁLOGOS</span>
          </div>
        </div>
        <!-- </a> -->
      </div>
      }
      <!-- End::catálogos (sm y md) -->

      <!-- Start::catálogos xs -->
      @if(countryCode!== 'pe'){
      <div
        class="col-12 py-0 block lg:hidden"
        style="cursor: pointer; margin-left: 0px; margin-bottom: 15px"
        (click)="openInNewTab('/catalogos/listado-catalogos')"
      >
        <!-- <a href="/catalogos/listado-catalogos" target="_blank"> -->
        <div class="row m-0">
          <div class="col-4 py-0 flex justify-content-center">
            <img
              ngSrc="../../../../../assets/svg/13.svg"
              width="50"
              height="70"
              alt="catálogos"
            />
          </div>
          <div
            class="col-8 py-0 flex flex-column justify-content-center"
            style="color: #094cac"
          >
            <span>Nuestros</span>
            <span class="fw-bold">CATÁLOGOS</span>
          </div>
        </div>
        <!-- </a> -->
      </div>
      }
      <!-- End::catálogos xs -->
    </div>
  </div>
</div>

<!-- Start::newsletter -->
<div class="newsletter position-relative">
  <picture>
    <source
      srcset="../../../../../assets/images/banners/Banner-implementos_01.webp"
      type="image/webp"
    />
    <source
      srcset="../../../../../assets/images/banners/Banner-implementos_01.png"
      type="image/png"
    />
    <img
      src="../../../../../assets/images/banners/Banner-implementos_01.webp"
      class="bg"
      alt="newsletter"
    />
  </picture>

  <div class="container absolute sm:p-1">
    <!-- Start::newsletter (+sm) -->
    <div
      class="offset-5 col-7 py-0 hidden sm:flex flex-column align-items-center"
    >
      <div class="text-center titulo">NEWSLETTER</div>
      <div class="text-center">
        Suscríbete y mantente informado acerca de nuestras ofertas, noticias y
        eventos.
      </div>
      <div class="formulario flex w-100 mt-3">
        <input
          class="col py-0 text-base px-3"
          name="correo"
          placeholder="Ingresar correo"
          aria-label="correo"
          type="text"
          autocomplete="off"
        />
        <button type="button">Registrarse</button>
      </div>
      <div class="mt-2 align-self-end">
        <input type="checkbox" aria-label="aceptar" /> *Aceptar
        <span style="text-decoration: underline">Términos y condiciones</span>
      </div>
    </div>
    <!-- End::newsletter (+sm) -->

    <!-- Start::newsletter (xs) -->
    <div
      class="flex flex-column col-12 py-0 align-items-center block lg:hidden"
    >
      <div class="text-center titulo">NEWSLETTER</div>
      <div class="text-center">
        Suscríbete y mantente informado acerca de nuestras ofertas, noticias y
        eventos.
      </div>
      <div class="formulario_mobile flex w-100 mt-3">
        <input
          class="col py-0 text-base px-3"
          name="correo"
          placeholder="Ingresar correo"
          aria-label="correo"
          type="text"
          autocomplete="off"
        />
      </div>
      <div class="formulario_mobile flex w-100 mt-3">
        <button type="button">Registrarse</button>
      </div>
      <div class="mt-2 align-self-end">
        <input type="checkbox" /> *Aceptar
        <span style="text-decoration: underline">Términos y condiciones</span>
      </div>
    </div>
    <!-- End::newsletter (xs) -->
  </div>
</div>
<!-- End::newsletter -->

<!-- Start::footer (+lg) -->
<div class="site-footer hidden lg:block">
  <div class="container">
    <div class="py-2">
      <div class="row m-0">
        <div class="col-custom ps-0">
          <app-sobre-nosotros></app-sobre-nosotros>
        </div>
        <div class="col-custom px-0">
          <app-holding-epysa></app-holding-epysa>
        </div>
        <div class="col-custom hidden lg:block px-0">
          <app-mi-cuenta></app-mi-cuenta>
        </div>
        <div class="col ps-0 py-0">
          <app-contactanos></app-contactanos>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 fw-bold" style="font-size: 0.8rem">
        Implementos es la red de repuestos, insumos y accesorios para camiones,
        buses y remolques más grande del país.
      </div>
    </div>
  </div>
  <div style="height: 30px; background-color: #000"></div>
</div>
<!-- End::footer (+lg) -->

<!-- Start::footer xs, sm y md -->
<div class="site-footer block lg:hidden">
  <app-fotter-site-mobile>-</app-fotter-site-mobile>
</div>
}
<!-- End::footer xs, sm y md -->
